// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import MobileWantedCreate from './MobileWantedCreate';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(MobileWantedCreate);
